import { Loader2 } from 'lucide-react';

interface LoadingStateProps {
  message?: string;
  height?: string;
}

export default function LoadingState({ message = "Carregando dados...", height = "h-48" }: LoadingStateProps) {
  return (
    <div className={`${height} flex flex-col items-center justify-center text-gray-500`}>
      <Loader2 className="w-8 h-8 mb-2 animate-spin" />
      <p>{message}</p>
    </div>
  );
}